import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { Timer } from "lucide-react";
type FastFillingLabelProps = {
  className?: string;
};
export const FillingFast = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("text-destructive flex items-center justify-center gap-0.5 text-xs font-bold italic", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="relative inline-flex items-center"><span className="absolute left-0 flex h-3 -translate-x-2.5 flex-col items-end justify-between"><span className="bg-destructive block h-0.5 w-1 rounded-full" /><span className="bg-destructive block h-0.5 w-2 rounded-full" /><span className="bg-destructive block h-0.5 w-3 rounded-full" /></span><Timer size={20} /></span>;
    t3 = <span className="mt-1 tracking-wide">Seats filling fast</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <span className={t1}>{t2}{t3}</span>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};